import store from "../../store";
import Axios from "axios";

const apiBaseUrl = `${process.env.VUE_APP_API_ENDPOINT}/api`;
const defaultHeaders = { 'Accept': 'application/json', 'Content-Type': 'application/json' };

export const axiosConsumer = ()=> {
  let headers = Object.assign({ }, defaultHeaders);
  const oidcAccessToken = store.getters['oidcStore/oidcAccessToken'] || null;
  const argoAccessToken = store.getters['argoStore/sessionToken'] || null;
  
  if(oidcAccessToken != null) headers['Authorization'] = `Bearer ${oidcAccessToken}`;
  if(argoAccessToken != null) headers['x-auth-token'] = `${argoAccessToken}`;

  return Axios.create({ baseURL: apiBaseUrl, headers: headers });
};
